export * from "./TablePagination";
//# sourceMappingURL=index.js.map